import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/icons/mercury-pc.png';
import IconCloud from '../../assets/images/icons/svg/cloud-sun.svg';
import IconSun from '../../assets/images/icons/svg/sun.svg';
import IconWind from '../../assets/images/icons/svg/wind.svg';
import ConfigData from '../../config.json';
import { UserAgentApplication } from 'msal';
import { gapi } from 'gapi-script';
import Swal from 'sweetalert2';
import authenService from '../../services/authenService';
import {
    SetDataEmail,
    SetDataFullName,
    SetDataMenuData,
    SetDataRefreshToken,
    SetDataToken,
    SetDataUserGroup,
    SetDataUserID,
} from '../../components/utils/data-storage';
import MapGroupScreenService from '../../services/mapGroupScreenService';

const MESSENGER_GROUP_ID = 3;

const Login = () => {
    const navigate  = useNavigate();
    const msAuthRef = useRef(null);

    const [email, setEmail]           = useState('');
    const [password, setPassword]     = useState('');
    const [emailError, setEmailError] = useState('');
    const [loading, setLoading]       = useState(false);

    useEffect(() => {
        localStorage.clear();
        const msConfig = {
            auth: {
                clientId: 'b62024cf-cff5-492e-972d-153c0828cc42',
                redirectUri: ConfigData.APP_REDIRECT_LOGIN,
            },
        };
        msAuthRef.current = new UserAgentApplication(msConfig);

        gapi.load('auth2', () => {
            gapi.auth2.init({
                client_id: '339150796613-qogfll9tk3s27m8dfenpdb4ajhqrltge.apps.googleusercontent.com',
            });
        });
    }, []);

    const onClickLoginGoogle = () => {
        gapi.auth2.getAuthInstance().signIn()
            .then((googleUser) => {
                checkLoginAuto(googleUser.getBasicProfile().getEmail());
            })
            .catch((error) => console.error('Login failed: ' + error.error));
    };

    const onClickLoginMicrosoft = () => {
        if (!msAuthRef.current) return;
        msAuthRef.current
            .loginPopup({ scopes: ['User.Read'] })
            .then((response) => {
                if (response) {
                    checkLoginAuto(response.account.userName);
                }
            })
            .catch(console.error);
    };

    const checkLoginAuto = async (emailVal) => {
        setLoading(true);
        try {
            const respLogin = await authenService.Login({ email: emailVal, scopes: ['read_write'] });
            if (respLogin?.data?.is_success === true) {
                const result = respLogin.data.result;
                SetDataToken(result.token.access_token);
                SetDataRefreshToken(result.token.refresh_token);
                if (result.user_id > 0) {
                    SetDataUserID(result.user_id);
                    SetDataEmail(result.email);
                    SetDataFullName(`${result.name} ${result.surname}`);
                    SetDataUserGroup(result.user_group_id);

                    if (String(result.user_group_id) === String(MESSENGER_GROUP_ID)) {
                        navigate('/messenger/myjob', { replace: true });
                    } else {
                        const respScreen = await MapGroupScreenService.GetMapGroupScreens({
                            id_user_group: result.user_group_id,
                            status: 1,
                        });
                        SetDataMenuData(respScreen.data.result || []);
                        if (result.user_group_id === 2) navigate('/admin/requests', { replace: true });
                        else if (result.user_group_id === 4) navigate('/admin/report-requests', { replace: true });
                        else navigate('/user/requests', { replace: true });
                    }
                } else {
                    SetDataEmail(emailVal);
                    navigate('/profile/' + btoa(emailVal + '::LGN'), { replace: true });
                }
            } else {
                showLoginError();
            }
        } catch (error) {
            showLoginError();
        } finally {
            setLoading(false);
        }
    };

    const onClickLoginManual = () => {
        if (!email.trim()) {
            setEmailError('ไม่มีอีเมลนี้');
            return;
        }
        setEmailError('');
        checkLoginManual(email.trim(), password);
    };

    const checkLoginManual = async (emailVal, passwordVal) => {
        setLoading(true);
        try {
            const respLogin = await authenService.LoginMessenger({
                username: emailVal,
                password: passwordVal,
                scopes: ['read_write'],
            });
            if (respLogin?.data?.is_success === true) {
                const result = respLogin.data.result;
                SetDataToken(result.token.access_token);
                SetDataRefreshToken(result.token.refresh_token);
                if (result.user_id > 0) {
                    SetDataUserID(result.user_id);
                    SetDataEmail(result.email);
                    SetDataFullName(`${result.name} ${result.surname}`);
                    SetDataUserGroup(result.user_group_id);
                    if (String(result.user_group_id) === String(MESSENGER_GROUP_ID)) {
                        navigate('/messenger/myjob', { replace: true });
                    } else {
                        navigate('/messenger/noaccount', { replace: true });
                    }
                } else {
                    navigate('/messenger/noaccount', { replace: true });
                }
            } else {
                navigate('/messenger/noaccount', { replace: true });
            }
        } catch (error) {
            console.error(error);
            navigate('/messenger/noaccount', { replace: true });
        } finally {
            setLoading(false);
        }
    };

    const showLoginError = () => {
        Swal.fire({
            icon: 'warning',
            title: 'Unable to Log in',
            text: 'You can log in using your internal email address. or double check the authenticity of your email.',
            confirmButtonColor: '#0778FF',
        });
    };

    return (
        <div className="lp-root">
            <div className="lp-left">
                <div className="lp-logo">
                    <img src={Logo} alt="Mercury" />
                </div>

                <div className="lp-form-wrap">
                    {/* PC */}
                    <h1 className="lp-headline">Organize your<br />requests in one place.</h1>
                    {/* Mobile */}
                    <h1 className="mlp-title">เข้าสู่ระบบ</h1>

                    <p className="lp-sub">Logging in with internal e-mail</p>

                    <button className="lp-btn lp-btn--theme lp-btn--google" onClick={onClickLoginGoogle} disabled={loading}>
                        <svg width="18" height="18" viewBox="0 0 20 20">
                            <path fill="#4285F4" d="M19.6 10.23c0-.82-.1-1.42-.25-2.05H10v3.72h5.5c-.15.96-.74 2.31-2.04 3.22v2.45h3.16c1.89-1.73 2.98-4.3 2.98-7.34z"/>
                            <path fill="#34A853" d="M13.46 15.13c-.83.59-1.96 1-3.46 1-2.64 0-4.88-1.74-5.68-4.15H1.07v2.52C2.72 17.75 6.09 20 10 20c2.7 0 4.96-.89 6.62-2.42l-3.16-2.45z"/>
                            <path fill="#FBBC05" d="M3.99 10c0-.69.12-1.35.32-1.97V5.51H1.07A9.973 9.973 0 000 10c0 1.61.39 3.14 1.07 4.49l3.24-2.52c-.2-.62-.32-1.28-.32-1.97z"/>
                            <path fill="#EA4335" d="M10 3.88c1.88 0 3.13.81 3.85 1.48l2.84-2.76C14.96.99 12.7 0 10 0 6.09 0 2.72 2.25 1.07 5.51l3.24 2.52C5.12 5.62 7.36 3.88 10 3.88z"/>
                        </svg>
                        Login with Email
                    </button>

                    <button className="lp-btn lp-btn--theme" onClick={onClickLoginMicrosoft} disabled={loading}>
                        <svg width="18" height="18" viewBox="0 0 20 20">
                            <path fill="#f25022" d="M0 0h9.5v9.5H0z"/>
                            <path fill="#00a4ef" d="M10.5 0H20v9.5h-9.5z"/>
                            <path fill="#7fba00" d="M0 10.5h9.5V20H0z"/>
                            <path fill="#ffb900" d="M10.5 10.5H20V20h-9.5z"/>
                        </svg>
                        Login with Microsoft 365
                    </button>
                </div>
            </div>

            <div className="lp-right">
                <div className="bg-lp-right">
                    <p className="lp-terms-title">
                        เงื่อนไขการใช้บริการรับ-ส่งเอกสาร<br />
                        ห้อง MERCURY STATION ชั้น G อาคารฝั่ง South Tower
                    </p>
                    <div className="lp-cards">
                        <div className="lp-card">
                            <div className="lp-icon"><img src={IconCloud} alt="Icon Cloud" /></div>
                            <div className="lp-card-body">
                                <div className="lp-card-title">รอบเช้า</div>
                                <div className="lp-card-text">
                                    ต้องทำการจองในระบบ และนำเอกสารมาส่งที่ห้อง MERCURY STATION ก่อนล่วงหน้าอย่างน้อย 1 วัน <br />หากส่งเอกสารมาช้ากว่าเวลาที่กำหนดฝ่ายธุรการจะดำเนินการส่งให้ในรอบบ่าย
                                </div>
                            </div>
                        </div>
                        <div className="lp-card">
                            <div className="lp-icon"><img src={IconSun} alt="Icon Sun" /></div>
                            <div className="lp-card-body">
                                <div className="lp-card-title">รอบบ่าย</div>
                                <div className="lp-card-text">
                                    ต้องทำการจองในระบบ และนำเอกสารมาส่งที่ห้อง MERCURY STATION ก่อนเวลา 11.00 น. <br />หากส่งเอกสารมาช้ากว่าเวลาที่กำหนด ฝ่ายธุรการจะดำเนินการส่งให้ในรอบเช้าของวันถัดไป
                                </div>
                            </div>
                        </div>
                        <div className="lp-card">
                            <div className="lp-icon"><img src={IconWind} alt="Icon Wind" /></div>
                            <div className="lp-card-body">
                                <div className="lp-card-title">เอกสารด่วน</div>
                                <div className="lp-card-text">
                                    ต้องทำการจองในระบบ และเอกสารมาส่งที่ห้อง MERCURY STATION <br />พร้อมทั้งติดต่อประสานกับฝ่ายธุรการโดยตรง
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="lp-note">
                        <div className="lp-note-title">หมายเหตุ</div>
                        <ul>
                            <li>ผู้ใช้บริการพนักงานรับ-ส่งเอกสาร ต้องส่งคำขอการใช้บริการผ่านระบบ Messenger Service เท่านั้น</li>
                            <li>ผู้ใช้บริการต้องนำเอกสารมาส่งให้เจ้าหน้าที่ ณ ห้อง MERCURY STATION ชั้น G อาคารฝั่ง South Tower ตามเวลาที่กำหนด</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;